<template>
  <div
    ref="search-bar"
    class="search-bar"
    tabindex="0"
    @focusout="handleFocusOut"
  >
    <label
      v-if="label"
      class="label"
    >
      {{ label }}
    </label>
    <div>
      <input
        :value="modelValue"
        :placeholder="placeholder"
        :data-test="dataTest"
        aria-label="Search"
        @input="$emit('update:modelValue', $event.target.value)"
        @keydown.down.prevent="downButtonPressed"
        @keydown.up.prevent="upButtonPressed"
        @keydown.enter.prevent="enterButtonPressed"
      />

      <SearchIcon />
      <ul v-if="searchResults.length > 0">
        <li
          v-for="(result, i) in searchResults"
          :key="customKey ? result[customKey] : result.id"
          :class="{ active: i === active }"
          :data-test="dataTest ? (result.name ?? result.title) : null"
          @click="onClick(result)"
          @mouseover="active = i"
          @mouseleave="active = null"
        >
          {{ result.name ?? result.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SearchIcon from '~/components/Common/Svg/SearchIcon';

export default {
  components: { SearchIcon },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    searchResults: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    customKey: {
      type: String,
      default: '',
    },
    dataTest: {
      type: String,
      default: '',
    },
  },
  emits: [
    'update:modelValue',
    'selectRole',
    'enterKeyPressed',
    'focusout',
    'input',
  ],
  data() {
    return {
      active: null,
    };
  },
  watch: {
    value() {
      this.active = null;
    },
  },
  methods: {
    downButtonPressed() {
      if (this.active === this.searchResults.length - 1) {
        return;
      }

      this.active === null ? (this.active = 0) : (this.active += 1);
    },
    upButtonPressed() {
      if (this.active !== null && this.active !== 0) {
        this.active -= 1;
      }
    },
    enterButtonPressed() {
      if (this.active !== null) {
        this.$emit('selectRole', this.searchResults[this.active]);
        this.active = null;
      } else {
        this.$emit('enterKeyPressed');
      }
    },
    handleFocusOut(e) {
      if (this.$refs['search-bar']?.contains(e?.relatedTarget)) {
        return;
      }
      this.$emit('input', '');
      this.$emit('focusout');
    },
    onClick(result) {
      this.$emit('selectRole', result);
      this.$emit('input', '');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './SearchBarNew.scss';
</style>
